import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-lg p-3 text-left text-textPrimary",
  "data-testid": "handover-history-event"
}
const _hoisted_2 = {
  class: "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold mb-3",
  style: {"background-color":"#edf5ff","border-color":"#0f62fe","color":"#0f62fe"},
  "data-testid": "handover-history-event-badge"
}
const _hoisted_3 = {
  class: "w-4 h-4 shrink-0",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "flex items-center gap-3 flex-wrap" }
const _hoisted_6 = {
  class: "flex items-center gap-2 min-w-0",
  "data-testid": "handover-history-event-from"
}
const _hoisted_7 = { class: "flex items-center justify-center w-9 h-9 rounded-full bg-neutral-200 text-xs font-bold text-textPrimary shrink-0" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs font-semibold text-[#7f7f8e]" }, "Passou", -1)
const _hoisted_10 = { class: "block truncate font-medium" }
const _hoisted_11 = {
  class: "w-5 h-5 shrink-0",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  style: {"color":"#0f62fe"}
}
const _hoisted_12 = ["d"]
const _hoisted_13 = {
  class: "flex items-center gap-2 min-w-0",
  "data-testid": "handover-history-event-to"
}
const _hoisted_14 = { class: "flex items-center justify-center w-9 h-9 rounded-full bg-neutral-200 text-xs font-bold text-textPrimary shrink-0" }
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs font-semibold text-[#7f7f8e]" }, "Recebeu", -1)
const _hoisted_17 = { class: "block truncate font-medium" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1)
const _hoisted_19 = {
  class: "text-[#666]",
  "data-testid": "handover-history-event-footer"
}
const _hoisted_20 = { class: "text-[#666] text-sm" }
const _hoisted_21 = {
  key: 1,
  class: "bg-white rounded-lg p-3 text-left text-textPrimary"
}
const _hoisted_22 = {
  key: 0,
  class: "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold mb-3",
  style: {"background-color":"#eef6f7","border-color":"#2f7f91","color":"#2f7f91"},
  "data-testid": "permanence-history-badge"
}
const _hoisted_23 = {
  class: "inline-flex rounded px-2 py-0.5 text-xs font-semibold mb-2 bg-[#E9E9F1] text-[#3E3E5A]",
  "data-testid": "coverage-history-badge"
}
const _hoisted_24 = {
  class: "font-bold text-md mb-1",
  "data-testid": "coverage-history-title"
}
const _hoisted_25 = { class: "text-sm text-[#666] mb-2" }
const _hoisted_26 = {
  key: 0,
  class: "text-sm mb-2",
  "data-testid": "coverage-history-status"
}
const _hoisted_27 = { class: "font-bold text-md mb-2" }
const _hoisted_28 = { class: "font-normal" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = { class: "font-bold text-md mt-2 mb-2" }
const _hoisted_31 = { class: "flex items-center gap-2 bg-neutral-200 py-1 px-2 rounded-md mb-2" }
const _hoisted_32 = {
  key: 0,
  class: "truncate min-w-0"
}
const _hoisted_33 = { class: "truncate min-w-0" }
const _hoisted_34 = {
  key: 3,
  class: "text-[#666]"
}
const _hoisted_35 = {
  key: 4,
  class: "text-[#666] text-xs mt-1",
  "data-testid": "permanence-history-note"
}

import { mdiArrowRightThin, mdiSwapHorizontal } from '@mdi/js'
import { computed, ref } from 'vue'
import { EditHistoryChange, EditHistoryUser } from '@/Network/Types/Responses/EditHistoryResponses'
import { timezones } from '@/hooks/useCommon'
import { humanizeDSReminderStatus } from '@/utils/doctorStation'
import { formatHourMinuteInOffset } from '@/utils/date'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { describeCoverageHistoryEvent } from '@/utils/coverageHistory'
import { UNIDENTIFIED_COVERAGE_LABEL } from '@/utils/coverage'

const COVERAGE_RESPONSIBLE_LABEL = 'Responsável pela cobertura'

interface ParsedHandoverDoctor {
  name: string
  crm: string
  initials: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryCard',
  props: {
    user: {},
    createdAt: {},
    changes: {},
    timezone: {},
    type: {},
    isAutoPermanence: { type: Boolean },
    permanenceNote: {}
  },
  setup(__props: any) {

const props = __props;

const COVERAGE_STATUS_HISTORY_LABELS: Record<string, string> = {
  OPEN: 'Vaga aberta',
  DOCTOR: 'Com médico',
  UNIDENTIFIED: UNIDENTIFIED_COVERAGE_LABEL
}



const { flags } = useFeatureFlags()

// M12-A — evento semântico de cobertura (ocupado sem identificação): o card
// mostra a narrativa + linha de status e deixa o diff bruto recolhido.
const coverageEvent = computed(() => describeCoverageHistoryEvent(props.changes, props.type))
const showCoverageDiff = ref(false)

// Evento estruturado de troca de plantão (contrato C2 do audits): backend
// devolve type HANDOVER_APPROVED com um change key="doctor" no formato
// "Nome (CRM xxxx)" — parseado defensivamente pois o CRM é opcional/variável.
const isHandoverApproved = computed(() => props.type === 'HANDOVER_APPROVED')

const buildInitials = (name: string): string => {
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}

const parseHandoverDoctor = (value: string | boolean | null | undefined): ParsedHandoverDoctor => {
  const raw = typeof value === 'string' ? value.trim() : ''
  const match = raw.match(/^(.*?)\s*\(\s*CRM[:.\s]*([^)]*)\)\s*$/i)
  const name = (match ? match[1] : raw).trim()
  const crm = (match ? match[2] : '').trim()
  return { name, crm, initials: buildInitials(name) }
}

const handoverDoctorChange = computed(() =>
  props.changes?.find((change) => change.key === 'doctor')
)

const handoverFrom = computed(() => parseHandoverDoctor(handoverDoctorChange.value?.from))
const handoverTo = computed(() => parseHandoverDoctor(handoverDoctorChange.value?.to))

// user = quem efetivou a troca (contrato C2). Quando é o próprio médico B
// (efetivação automática sem admin), o rodapé troca "Aprovado por" pelo aviso.
const isAutomaticEffectuation = computed(() => {
  const doctorName = handoverTo.value.name.trim().toLowerCase()
  const approverName = props.user?.name?.trim().toLowerCase()
  if (!doctorName || !approverName) return false
  return doctorName === approverName
})

const actionText = computed(() => {
  const map: Record<string, string> = {
    STATION: 'editou esse plantão',
    DOCTOR_STATION: 'editou esse plantão',
    DOCTOR_STATION_CREATE: 'criou esse plantão',
    CHECK: 'editou o check desse plantão',
    CHECK_CREATE: 'fez check-in nesse plantão',
    OBSERVATION_CREATE: 'adicionou uma observação',
    OBSERVATION_DELETE: 'apagou uma observação'
  }
  return map[props.type || ''] || 'editou esse plantão'
})

const formattedEditDate = computed(() => {
  if (!props.createdAt) return ''
  return `Em ${formatDate(props.createdAt)} às ${formatTime(props.createdAt, props.timezone)} (${timezoneTitle(props.timezone)})`
})

const timezoneTitle = (timezone: any) => {
  const found = timezones.find((tz) => tz.value === timezone)
  return found?.title
}

const formatDate = (value: string) => {
  const date = new Date(value)
  return date.toLocaleDateString('pt-BR')
}

const formatTime = (value: string, timezone: string | undefined) => {
  const date = new Date(value)
  // Fuso em formato de offset ISO (ex.: '-03:00', o valor padrão persistido
  // pelo backend — ver `timezones` em `src/hooks/useCommon.ts`) faz a opção
  // `timeZone` do `Intl` lançar `RangeError: Invalid time zone specified`,
  // que só aceita nome IANA. Esse é o caminho comum, então detectamos o
  // formato de offset ANTES de chamar o Intl e usamos o fallback direto,
  // sem passar pelo try/catch (evita warn no console a cada render).
  if (timezone && /^[+-]\d{2}:\d{2}$/.test(timezone)) {
    return formatHourMinuteInOffset(value, timezone) ?? ''
  }
  try {
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezone
    })
  } catch (error) {
    // Caminho excepcional: fuso não é offset nem nome IANA reconhecido pelo
    // Intl. Mesmo fallback já usado em `src/utils/date.ts` para o
    // pós-plantão: aritmética de offset em vez do `Intl`.
    console.warn('HistoryCard: fallback de formatTime para fuso não-IANA', timezone, error)
    return formatHourMinuteInOffset(value, timezone ?? '') ?? ''
  }
}

const formattedChanges = computed(() => {
  const fieldMap = {
    doctor_id: 'Médico',
    doctor: 'Médico',
    our_team: 'Time Interno',
    ourTeam: 'Time Interno',
    date: 'Data',
    value: 'Valor',
    inCash: 'Modalidade de repasse',
    timezone: 'Fuso Horário',
    request_antecipe: 'Adiantamento solicitado',
    requestAntecipe: 'Adiantamento solicitado',
    antecipe_was_paid: 'Adiantamento pago',
    antecipeWasPaid: 'Adiantamento pago',
    user_sponsor_id: 'Escalado por',
    userSponsorId: 'Escalado por',
    userSponsor: 'Escalado por',
    start_hour: 'Data e hora de início',
    startHour: 'Data e hora de início',
    end_hour: 'Data e hora de fim',
    endHour: 'Data e hora de fim',
    type: 'Periodicidade',
    isActive: 'Status da vaga',
    paymentRule: 'Regra de proporcionalidade',
    company: 'Empresa',
    modifiedValue: 'Modificou o valor',
    doctor_confirmed: 'Confirmou esse plantão',
    doctorConfirmed: 'Confirmou esse plantão',
    lastUpdaterUserId: 'Editou esse plantão',
    updatedAt: 'Em',
    paymentValue: 'Valor',
    ds_payment_doctor_formation_id: 'Formação',
    dsPaymentDoctorFormationId: 'Formação',
    dsPaymentDoctorFormation: 'Formação',
    insert_doctor_date: 'Data de inserção do médico',
    insertDoctorDate: 'Data de inserção do médico',
    position_id: 'Posição',
    positionId: 'Posição',
    position: 'Posição',
    doctor_station_observation_created: 'Observação criada',
    doctorStationObservationCreated: 'Observação criada',
    doctor_station_observation_deleted: 'Observação apagada',
    doctorStationObservationDeleted: 'Observação apagada',
    doctor_station_reminder_status: 'Status do lembrete de plantão',
    doctorStationReminderStatus: 'Status do lembrete de plantão',
    doctor_station_reminder_accepted_date: 'Data aceite lembrete de plantão',
    doctorStationReminderAcceptedDate: 'Data aceite lembrete de plantão',
    checkin: 'Check-in',
    checkin_latitude: 'Check-in latitude',
    checkin_longitude: 'Check-in longitude',
    checkout: 'Check-out',
    checkout_latitude: 'Check-out latitude',
    checkout_longitude: 'Check-out longitude',
    in_cash: 'Modalidade de repasse',
    doctor_station_reminder_rejected_date: 'Data rejeição lembrete de plantão',
    doctorStationReminderRejectedDate: 'Data rejeição lembrete de plantão',
    unregistered_doctor: 'Sem identificação',
    unregisteredDoctor: 'Sem identificação',
    coverage_responsible: COVERAGE_RESPONSIBLE_LABEL,
    coverageResponsible: COVERAGE_RESPONSIBLE_LABEL,
    coverage_responsible_id: COVERAGE_RESPONSIBLE_LABEL,
    coverageResponsibleId: COVERAGE_RESPONSIBLE_LABEL,
    coverage_responsible_name: COVERAGE_RESPONSIBLE_LABEL,
    coverageResponsibleName: COVERAGE_RESPONSIBLE_LABEL,
    coverage_note: 'Observação da cobertura',
    coverageNote: 'Observação da cobertura',
    // O BE manda a chave crua da coluna; o rótulo humano é montado aqui.
    coverage_status: 'Situação da cobertura',
    coverageStatus: 'Situação da cobertura'
  }

  const formatValue = (value: string | boolean | null): string => {
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não'
    if (value === null || value === '') return 'Vazio'
    return String(value)
  }

  // Valor desconhecido (enum novo no BE) passa cru em vez de sumir.
  const formatCoverageStatus = (value: string | boolean | null): string =>
    COVERAGE_STATUS_HISTORY_LABELS[String(value)] ?? formatValue(value)

  function formatChanges(): EditHistoryChange[] {
    const removeFields = [
      'date',
      'last_updater_user_id',
      'lastUpdaterUserId',
      'updatedAt',
      'updated_at',
      'isActive',
      'is_active',
      'createdAt',
      'created_at',
      'id',
      'deleted_at',
      'deletedAt',
      'doctor_station',
      'doctor_station_id',
      'doctorStationId',
      'is_main',
      'origin'
    ]
    const filteredChanges = props.changes?.filter((change) => !removeFields.includes(change.key))

    // Reordenação dos campos
    const startKeys = ['start_hour', 'startHour']
    const endKeys = ['end_hour', 'endHour']
    const startObject = filteredChanges.find((obj) => startKeys.includes(obj.key))
    const endObject = filteredChanges.find((obj) => endKeys.includes(obj.key))
    if (startObject && endObject) {
      const othersObjects = filteredChanges.filter(
        (obj) => !startKeys.includes(obj.key) && !endKeys.includes(obj.key)
      )
      return [startObject, endObject, ...othersObjects]
    }
    return filteredChanges
  }

  const formattedChanges = formatChanges()
  // eslint-disable-next-line complexity
  return formattedChanges?.map((change) => {
    const dateValues = [
      'endHour',
      'startHour',
      'start_hour',
      'end_hour',
      'insert_doctor_date',
      'insertDoctorDate',
      'date',
      'doctor_station_reminder_accepted_date',
      'doctorStationReminderAcceptedDate',
      'created_at',
      'updated_at',
      'createdAt',
      'updatedAt',
      'checkout',
      'checkin'
    ]
    if (dateValues.includes(change.key)) {
      return {
        key: fieldMap[change.key] || change.key,
        from:
          change.from === 'Vazio'
            ? change.from
            : `${formatDate(String(change.from))} ${formatTime(String(change.from), props.timezone)}`,
        to:
          change.to === 'Vazio'
            ? change.to
            : `${formatDate(String(change.to))} ${formatTime(String(change.to), props.timezone)}`
      }
    }
    if (change.key === 'timezone') {
      return {
        key: fieldMap[change.key] || change.key,
        from: change.from === 'Vazio' ? change.from : timezoneTitle(change.from),
        to: change.to === 'Vazio' ? change.to : timezoneTitle(change.to)
      }
    }
    if (
      change.key === 'doctor_station_reminder_status' ||
      change.key === 'doctorStationReminderStatus'
    ) {
      return {
        key: fieldMap[change.key] || change.key,
        from: humanizeDSReminderStatus(change.from),
        to: humanizeDSReminderStatus(change.to)
      }
    }
    if (change.key === 'coverage_status' || change.key === 'coverageStatus') {
      return {
        key: fieldMap[change.key],
        from: formatCoverageStatus(change.from),
        to: formatCoverageStatus(change.to)
      }
    }
    return {
      key: fieldMap[change.key] || change.key,
      from: formatValue(change.from),
      to: formatValue(change.to)
    }
  })
})

const visibleChanges = computed(() =>
  coverageEvent.value && !showCoverageDiff.value ? [] : formattedChanges.value
)

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (isHandoverApproved.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _createElementVNode("path", {
              d: _unref(mdiSwapHorizontal),
              fill: "currentColor"
            }, null, 8, _hoisted_4)
          ])),
          _createTextVNode(" Troca de plantão ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(handoverFrom.value.initials), 1),
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(handoverFrom.value.name), 1),
                (handoverFrom.value.crm)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" (CRM " + _toDisplayString(handoverFrom.value.crm) + ")", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_openBlock(), _createElementBlock("svg", _hoisted_11, [
            _createElementVNode("path", {
              d: _unref(mdiArrowRightThin),
              fill: "currentColor"
            }, null, 8, _hoisted_12)
          ])),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(handoverTo.value.initials), 1),
            _createElementVNode("span", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, [
                _createTextVNode(_toDisplayString(handoverTo.value.name), 1),
                (handoverTo.value.crm)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" (CRM " + _toDisplayString(handoverTo.value.crm) + ")", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, [
          (isAutomaticEffectuation.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Efetivada automaticamente")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Aprovado por "),
                _createElementVNode("strong", null, _toDisplayString(props.user?.name), 1)
              ], 64))
        ]),
        _createElementVNode("p", _hoisted_20, _toDisplayString(formattedEditDate.value), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
        (_unref(flags).enabledPermanenceRecord && _ctx.isAutoPermanence)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 🔗 REGISTRO DE PERMANÊNCIA "))
          : _createCommentVNode("", true),
        (coverageEvent.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(coverageEvent.value.badge), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(coverageEvent.value.title), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(props.user?.name) + " · " + _toDisplayString(formattedEditDate.value), 1),
              (coverageEvent.value.statusFrom)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Status " + _toDisplayString(coverageEvent.value.statusFrom) + " → " + _toDisplayString(coverageEvent.value.statusTo), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "text-sm font-bold text-primary30 underline",
                "data-testid": "coverage-history-toggle-diff",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showCoverageDiff.value = !showCoverageDiff.value))
              }, _toDisplayString(showCoverageDiff.value ? 'Ocultar campos alterados' : 'Ver campos alterados'), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("p", _hoisted_27, [
                _createTextVNode(_toDisplayString(props.user?.name) + " ", 1),
                _createElementVNode("span", _hoisted_28, _toDisplayString(actionText.value), 1)
              ]),
              _hoisted_29
            ], 64)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleChanges.value, (change) => {
          return (_openBlock(), _createElementBlock("div", {
            key: change.key
          }, [
            _createElementVNode("p", _hoisted_30, _toDisplayString(change.key), 1),
            _createElementVNode("div", _hoisted_31, [
              (change.from !== 'hide_field')
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _createTextVNode(_toDisplayString(change.from) + " ", 1),
                    (change.from !== 'hide_field')
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top start",
                          "max-width": "250"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(String(change.from)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (change.from !== 'hide_field')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    color: "text-textPrimary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(mdiArrowRightThin)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_33, [
                _createTextVNode(_toDisplayString(change.to) + " ", 1),
                (change.to !== 'hide_field')
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent",
                      location: "top end",
                      "max-width": "250"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(String(change.to)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128)),
        (!coverageEvent.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(formattedEditDate.value), 1))
          : _createCommentVNode("", true),
        (_unref(flags).enabledPermanenceRecord && _ctx.isAutoPermanence && _ctx.permanenceNote)
          ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.permanenceNote), 1))
          : _createCommentVNode("", true)
      ]))
}
}

})